import React from 'react';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import SendEmailContainer from 'components/SendEmail';

const ScreenSendEmail = () => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={10} md={8}>
      <SendEmailContainer />
    </GridItem>
  </GridContainer>
);

export default ScreenSendEmail;
